export const company = {
  name: "XcelerateIT",
  tagline: "Automation-led cloud security and platform engineering.",
  intro:
    "We help modernise AWS platforms, harden security controls, and build automated delivery workflows that scale with any business.",
  cta: {
    primary: { label: "Book a strategy session", href: "#contact" },
    secondary: { label: "Explore services", href: "#services" }
  }
};

export const services = [
  {
    title: "Landing Zone & Multi-Account Foundations",
    description:
      "Design and uplift AWS environments with secure-by-default guardrails, strong identity baselines, and scalable service catalogs that enable safe, frictionless self-service.",
    outcomes: [
      "Enterprise-grade landing zones engineered to support hundreds of accounts with consistent governance",
      "Standardised network, identity, and access patterns aligned to your organisational domains and operating model",
      "Low-risk migration frameworks and playbooks designed to minimise downtime, disruption, and security exposure"
    ]
  },
  {
    title: "Automation-First Delivery & DevSecOps",
    description:
      "Build pipelines, golden paths, and reusable platform products that ship infrastructure and application changes safely across AWS, Azure, and on-premise estates.",
    outcomes: [
      "DevSecOps that builds security directly into every stage of development enabling faster and safer delivery and with confidence",
      "Service Catalog and Infrastructure as Code (IaC) modules your engineers can adopt quickly",
      "Deployment automation that keeps compliance evidence auditable"
    ]
  },
  {
    title: "Cloud Security Uplift & Monitoring",
    description:
      "Improve security and reliability across your cloud environment with proactive guardrails, automated remediation, and clear, real-time visibility across multi-account platforms.",
    outcomes: [
      "End-to-end observability. Metrics, logs, and traces unified to provide actionable insight into system health and performance",
      "Proactive incident prevention. Intelligent alerting, automated remediation, and runbooks to reduce MTTR and operational toil",
      "Reliability by design. SLIs, SLOs, and error budgets defined and embedded to balance speed, stability, and risk"
    ]
  }
];

export const experienceHighlights = [
  {
    client: "Public Sector",
    headline: "Delivered an AI-powered application with real-time speech and language capabilities",
    detail:
      "Designed and delivered an AI application enabling natural, conversational interaction through text-to-speech and speech-to-text, supporting large-scale digital education and research initiatives."
  },
  {
    client: "Large Corporate Enterprise",
    headline: "Built the enterprise Cloud Native Platform powering hundreds of workloads",
    detail:
      "Launched account factory, secure pipelines, and golden paths that enabled 100+ AWS accounts, automated compliance, and high-velocity digital delivery teams."
  },
  {
    client: "Local Startup Innovator",
    headline: "Delivered a consumer mobile app used to capture and share live event experiences",
    detail:
      "A mobile application that automatically aggregates photos and media from live events into a single shared experience. Frictionless with no invitations, codes, or setup required allowing people to capture moments naturally while the platform works seamlessly in the background."
  }
];

export const principles = [
  {
    title: "Automation with accountability",
    description:
      "Every engagement delivers repeatable patterns, code, and runbooks so your teams can sustain and evolve the platform independently."
  },
  {
    title: "Security woven in",
    description:
      "Guardrails, identity, and observability are part of the first sprint—not an afterthought once the platform is live."
  },
  {
    title: "Transparent partnership",
    description:
      "Expect honest status, measurable outcomes, and co-ownership of decisions that balance risk, speed, and investment."
  }
];

export const team = {
  headline: "Cloud-secure. Automation-obsessed. Outcome-driven.",
  bio: [
    "Founded in Melbourne, Australia, XcelerateIT is a boutique consultancy specialising in modern cloud engineering, security automation, and applied AI platforms.",
    "We work with startups, scale-ups, and large organisations to design and deliver systems that are secure by default, automated end-to-end, and built to support real products — not just infrastructure.",
    "We stay close to the teams we support, pairing hands-on engineering with clear technical leadership to ensure platforms remain scalable, maintainable, and sustainable long after the engagement ends."
  ],
  highlights: [
    "We ship, not slide decks. Real platforms, real systems, real outcomes — not strategies that die in documentation.",
    "We think in outcomes, not tools. The technology serves the goal, not the other way around.",
    "We leave teams stronger. When we’re gone, your team owns the platform and knows how to evolve it."
  ]
};

export const contact = {
  headline: "Ready to modernise your cloud platform with confidence?",
  description:
    "Share a few details and I'll respond within one business day to explore your objectives, constraints, and how automation plus security can accelerate delivery.",
  successMessage: "Thanks! we'll be in touch very soon.",
  errorMessage:
    "Something went wrong. Please retry or message us directly at xcelerateit@outlook.com.",
  submissionEndpoint:
    "https://formsubmit.co/ajax/xcelerateit@outlook.com" // Replace with your chosen endpoint or API.
};

export const navigationLinks = [
  { label: "Services", href: "#services" },
  { label: "Experience", href: "#experience" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" }
];
